import { useEffect, RefObject } from 'react';

export function useRevealOnScroll(ref: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const targets = el.querySelectorAll('[data-reveal]');
    if (targets.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const delay = parseFloat(target.dataset.revealDelay || '0');
            setTimeout(() => {
              target.classList.add('is-revealed');
            }, delay * 1000);
            observer.unobserve(target);
          }
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px 80px 0px' },
    );

    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, [ref]);
}